import routeNames from './route-names'
import BaseRouterView from '@/components/base/BaseRouterView'

const Bespokes = () => import(/* webpackChunkName: "bespokes" */'@/views/bespoke/Bespokes')
const ManageBespoke = () => import(/* webpackChunkName: "bespokes" */'@/views/bespoke/bespoke/ManageBespoke')
const RemoveBespoke = () => import(/* webpackChunkName: "bespokes" */'@/views/bespoke/bespoke/RemoveBespoke')
const BespokeTabs = () => import(/* webpackChunkName: "bespokes" */'@/views/bespoke/BespokeTabs')
const Overview = () => import(/* webpackChunkName: "contacts" */'@/views/bespoke/bespoke/Overview')


function props (route) {
    return {
        bespokeId: parseInt(route.params.bespokeId)
    }
}

export default {
    path: '/tools/bespokes',
    alias: '/bespokes',
    component: BaseRouterView,
    children: [
        {
            path: '/',
            name: routeNames.BESPOKES,
            meta: {title: 'Bespokes'},
            component: Bespokes,
            props,
        },
        {
            path: ':bespokeId',
            component: BespokeTabs,
            props,
            children: [
                {
                    path: '/',
                    name: routeNames.BESPOKE,
                    meta: {title: 'Bespoke'},
                    component: Overview,
                    props: (route) => ({
                        bespokeId: parseInt(route.params.bespokeId)
                    }),
                }
            ]
        },
        {
            path: 'update/:bespokeId',
            name: routeNames.BESPOKE_UPDATE,
            props: (route) => ({
                bespokeId: parseInt(route.params.bespokeId)
            }),
            meta: {title: 'Update Bespoke'},
            component: ManageBespoke
        },
        {
            path: 'remove/:bespokeId',
            name: routeNames.BESPOKE_REMOVE,
            props: (route) => ({
                bespokeId: parseInt(route.params.bespokeId)
            }),
            meta: {title: 'Remove Bespoke'},
            component: RemoveBespoke
        },
    ]
}
